/*
 * Copyright (c) 2018 Helvia Technologies PC <contact@helvia.io>
 */

// Core imports
import React, { Fragment } from 'react';
import { useTranslation } from 'react-i18next';

// Component imports
import { Col, Form, Row, Select, Typography } from 'antd';
import { useFetchNlpPipelinesQuery } from '../../../../store/nlpPipelines/nlpPipelinesApi';

// Misc imports
import { useLocation, useParams } from 'react-router-dom';
import { getCurrentQueryState } from '../../../../store/utils/getCurrentQueryState';

// Constant declarations
const { Paragraph, Text } = Typography;

const NlpFlowPipelineNodeForm = () => {
  const { tenantId, orgId } = useParams();
  const { t } = useTranslation();
  const location = useLocation();

  const searchParams = new URLSearchParams(location.search);

  const { data: nlpPipelines, isFetching: isFetchingNlpPipelines } = useFetchNlpPipelinesQuery({ orgId, tenantId });
  const { currentData: nlpFlow, isLoading: isFetchingNlpFlow } = getCurrentQueryState('fetchNlpFlow', {
    orgId,
    tenantId,
    nlpFlowId: searchParams.get('nlpFlowId'),
    showError: false
  });

  return (
    <Fragment>
      <Row>
        <Col span={24}>
          <Text>
            {t('NLP System')}
          </Text>
        </Col>
        <Col span={24}>
          <Paragraph type="secondary">
            {t('Select one of the available Workspace NLP systems in the current flow language.')}
          </Paragraph>
        </Col>
      </Row>

      <Form.Item
        name={['data', 'pipelineId']}
        rules={[{ required: true, message: t('NLP System cannot be blank.') }]}
        className="mb-0"
      >
        <Select
          showSearch
          allowClear
          placeholder={t('Select NLP')}
          size="large"
          loading={isFetchingNlpPipelines || isFetchingNlpFlow}
          filterOption={(input, option) => {
            return option.label.toLowerCase().includes(input?.toLowerCase());
          }}
          options={(nlpPipelines?.items || [])
            .filter(pipeline => pipeline.language === nlpFlow?.language || pipeline.secondaryLanguages?.includes(nlpFlow?.language))
            .map(pipeline => {
              return {
                label: pipeline.name,
                value: pipeline.id
              };
            })}
        >
        </Select>
      </Form.Item>
    </Fragment>
  );
};

export default NlpFlowPipelineNodeForm;
